import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterAll'
})
export class SpecialPipe implements PipeTransform {

  // transform(value: any, searchText: any): any {
  //   if(!searchText) {
  //     return value;
  //   }
  //   searchText = searchText.toLowerCase();
  //   return value.filter((data) => 
  //   {
  //     let keys = Object.keys(data);
  //     let check : boolean = false;
  //     keys.forEach((element,i)=>
  //     {
  //       if(data[element].toLowerCase().startsWith(searchText))
  //       {
  //           check = true;
  //       }
  //     })
  //     return check;
  //   }); 
  // }

  transform(value: any, searchText: any): any {
    if(!searchText) {
      return value;
    }
    return value.filter((data) => this.matchValue(data,searchText)); 
  }

  matchValue(data, value) {
    return Object.keys(data).map((key) => {
       return new RegExp(value, 'gi').test(data[key]);
    }).some(result => result);
  }

}